import React from "react";
import "./announcementdisclosure.css"
const disclosureItems = [
  { id: 1, particular: "Stock Exchange Announcements" },
  { id: 2, particular: "Corporate Announcements" },
  { id: 3, particular: "Press Releases" },
  { id: 4, particular: "Newspaper Advertisements" },
  { id: 5, particular: "Disclosure under Regulation 30" },
  { id: 6, particular: "Compliance Disclosures" },
  { id: 7, particular: "Intimations & Notices" },
  { id: 8, particular: "Closure of Trading Window Notices" },
  
  { id: 9, particular: "Appointment / Resignation Disclosures" },
  { id: 10, particular: "Credit Rating Updates" },
  { id: 11, particular: "Disclosure of Material Events" },
  { id: 12, particular: "Postal Ballot Notices &  Results" },
  { id: 13, particular: "Investor Updates" },
  { id: 14, particular: " Notice of Board meetings" },
  { id: 15, particular: "Notice of general meeting Voting results" },
  { id: 16, particular: "Scrutinizer reports" },

];

const AnnouncementDisclosure = () => {
  return (
    <div className="main-container">
      {/* Hero Section — same structure as Career hero */}
      <section className="Career-hero-section">
        <div className="Career-heading">
          <h2> Announcements & Disclosure</h2>
        </div>
      </section>
      <section className="disclosure-section">
      <div className="disclosure-container">
        {/* <h1 className="disclosure-title">Regulation 46 of SEBI (LODR) 2015: Website Disclosure</h1> */}

        <div className="disclosure-table-wrapper">
          <table className="disclosure-table">
            <thead>
              <tr>
                <th className="col-sl">Sr. No.</th>
                <th className="col-particular">Announcements & Disclosure</th>
              </tr>
            </thead>
            <tbody>
              {disclosureItems.map((item, index) => (
                <tr key={item.id} className={index % 2 === 0 ? "row-even" : "row-odd"}>
                  <td className="col-sl">{item.id}.</td>
                  <td className="col-particular">{item.particular}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
    </div>
  );
};

export default AnnouncementDisclosure;
